import { Empty, Spin } from 'antd';
import { useMemo, useState } from 'react';
import useFarmerList from 'hooks/useFarmerList';

import { SearchOutlined } from '@ant-design/icons';
import MultiSelect from 'components/MultiSelect';

interface FarmerSearchProps {
  onSelect: (value: string[]) => void;
  selectedValues: string[];
  country: string;
  'data-testid'?: string;
}

const FarmerSearch = ({
  onSelect,
  selectedValues,
  country,
  'data-testid': dataTestId,
}: FarmerSearchProps) => {
  const [searchQuery, setSearchQuery] = useState<string | null>(null);

  const {
    data: farmerData,
    isLoading: isFarmerLoading,
    error: farmerError,
  } = useFarmerList(searchQuery!, country);

  const farmerOptions = useMemo(() => {
    return farmerData?.map((item) => ({
      label: item?.name,
      value: item?.id,
    }));
  }, [farmerData]);

  return (
    <MultiSelect
      label="Farmer"
      placeholder="Search Farmers"
      options={farmerOptions}
      onSearch={setSearchQuery}
      onChange={onSelect}
      loading={isFarmerLoading}
      notFoundContent={
        isFarmerLoading ? (
          <div className="d-flex justify-content-center my-2">
            <Spin spinning size="small" />
          </div>
        ) : (
          farmerError && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )
      }
      allowClear
      suffixIcon={<SearchOutlined className="pe-none" />}
      value={selectedValues}
      data-testid={dataTestId}
    />
  );
};

export default FarmerSearch;
